export const targetValue = ({ target }) => target.value;
